<template>
  <div class="page-video" :class="{'mobile': _isMobile}">
    <div class="video-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="8"></cmpBanner>

      <div class="g-wrap">
        <cmpTab :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab>

        <div class="g-content">
          <el-row class="list g-card-list" :gutter="_isMobile?0:39">
            <el-col class="item g-card-1" :span="_isMobile?24:12" v-for="(item, index) in dataList" :key="index">
              <div @click="goDetail(item)">
                <div class="pic-box pic1">
                  <img v-lazy="item.picture" alt="">
                  <div class="icon-play"></div>
                </div>
                <div class="info m-circle">
                  <h2 class="title m-font-2">{{item.name}}</h2>
                  <p class="time m-font-4">{{item.createTime}}</p>
                </div>
              </div>
            </el-col>

            <!-- 无数据 -->
            <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
              <div class="no-data-bg"></div>
              <p class="txt text-center">暂无数据</p>
            </div>
          </el-row>

          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/video/index.scss'
export default {
  watch: {
    $route(to, from) {
      this.activeVal = this.$route.query.pageType || '1'

      this.listQuery.page = 1
      this.getDataList()
    }
  },
  data() {
    return {
      activeVal: this.$route.query.pageType || '1',
      tabList: [
        {
          name: '讲解',
          val: '1'
        },
        {
          name: '宣传',
          val: '2'
        },
        {
          name: '讲座',
          val: '3'
        },
        {
          name: '其他',
          val: '4'
        }
      ],
      dataList: [],
      listQuery: {
        page: 1,
        size: 9,
      },
      total: '0',
      listLoading: false,
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('/webapi/video/list', {
          ...this.listQuery,
          type: this.activeVal
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.data
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.page = 1
      this.getDataList()
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getDataList()
    },
    goDetail(item) {
      window.open(item.video)
      // this.$router.push({
      //   path: '/activity/detail',
      //   query: {id: item.id, pageType: this.activeVal}
      // })
    },
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.video-wrap {
  font-size: 20px;
  .list {
    .item {
      .pic-box img {
        height: 348px;
      }
      .info {
        height: 122px;
      }
    }
  }
}
</style>


